import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';

const hasError = css`
  color: ${props => props.theme?.subLabel?.colorError};
`;

const SubLbl = styled.label`
  color: ${props => props.theme?.subLabel?.color};
  font-size: ${props => props.theme?.subLabel?.fontSize};
  font-weight: ${props => props.theme?.subLabel?.fontWeight};
  line-height: ${props => props.theme?.subLabel?.lineHeight};
  ${props => props.hasError ? hasError : null}
`;

const SubLblWrapper = styled.div`
  display: ${props => props.theme?.subLabel?.display || 'none'};
  &&& {
    margin-bottom: ${props => props.theme?.subLabel?.marginBottom};
  }
`;

const Optional = styled.span`
  color: ${props => props.theme?.optionalLabel?.color};
  display: ${props => props.theme?.optionalLabel?.display || 'inline'};
`;

Optional.defaultProps = {
  theme: {
    optionalLabel: {
      color: '#818181',
      display: 'inline'
    }
  }
};

const Required = styled.span`
  color: ${props => props.theme?.requiredLabel?.color};
  display: ${props => props.theme?.requiredLabel?.display || 'none'};
`;

Required.defaultProps = {
  theme: {
    requiredLabel: {
      color: '#c00404',
      display: 'none'
    }
  }
};

SubLbl.defaultProps = {
  theme: {
    label: {
      fontSize: '16px',
      color: '#000',
      colorError: '#E8141E'
    }
  }
};

export default class SubLabel extends Component {
  static propTypes = {
    label: PropTypes.oneOfType([PropTypes.string,PropTypes.object]).isRequired,
    hasError: PropTypes.bool,
    isOptional: PropTypes.bool
  };

  render () {
    return (
      <SubLblWrapper>
        <SubLbl hasError={this.props.hasError}>
          {this.props.label}
          {this.props.isOptional && <Optional>&nbsp;(optioneel)</Optional>}
          {!this.props.isOptional && <Required>&nbsp;*</Required>}
        </SubLbl>
      </SubLblWrapper>
    );
  }
}
